// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";

let keyThrustDevice = "thrustDevice";

let keySeenOfflineModeReady = "seenOfflineModeReady";

function getThrustDevice() {
  return Primitive_option.fromNull(localStorage.getItem(keyThrustDevice));
}

function hasSeenOfflineModeReady() {
  return Primitive_option.fromNull(localStorage.getItem(keySeenOfflineModeReady)) !== undefined;
}

function markSeenOfflineModeReady() {
  localStorage.setItem(keySeenOfflineModeReady, "1");
}

function useLocalStorage(key) {
  let match = React.useState(() => Primitive_option.fromNull(localStorage.getItem(key)));
  let setInternalValue = match[1];
  let setValue = maybeValue => {
    setInternalValue(param => maybeValue);
    if (maybeValue !== undefined) {
      localStorage.setItem(key, maybeValue);
    } else {
      localStorage.removeItem(key);
    }
  };
  React.useEffect(() => {
    let listener = param => setInternalValue(param => Primitive_option.fromNull(localStorage.getItem(key)));
    window.addEventListener("storage", listener);
    return () => {
      window.removeEventListener("storage", listener);
    };
  }, []);
  return [
    match[0],
    setValue
  ];
}

let keyWebAuthn = "webAuthn";

export {
  keyThrustDevice,
  keyWebAuthn,
  keySeenOfflineModeReady,
  getThrustDevice,
  hasSeenOfflineModeReady,
  markSeenOfflineModeReady,
  useLocalStorage,
}
/* react Not a pure module */
